module.exports = __webpack_public_path__ + "static/media/bizhengBanner.6c40a9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/bizhengImg/bizhengBanner.png
// module id = 1861
// module chunks = 1